module.exports = __webpack_public_path__ + "static/media/gen_sit_spe_met.3456fd50.png";